/* eslint-disable curly */
/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Confetti from 'react-dom-confetti';
import { useLocalStorage } from '../../hooks/useLocalStorage';

interface FranchiseeProps {}

const Franchisee: React.FC<FranchiseeProps> = () => {
    const { t } = useTranslation();
    const hasWindow = typeof window !== 'undefined' ? true : false;
    const { register, handleSubmit, errors, getValues, setValue, reset } = useForm();
    const [makeConfetti, setMakeConfetti] = useState<boolean>(false);
    const [storedFormData, setStoredFormData] = useLocalStorage('form_data', '');
    const [contactSetting, setContactSetting] = useState<string>('email');
    const confettiConfig = {
        spread: 175,
        startVelocity: 80,
        elementCount: 120,
    };

    useEffect(() => {
        if (!hasWindow) return;
        handleSetForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasWindow]);

    const onSubmit = (event: any) => {
        console.log(event);
        // Validate data...
        // Save form data (incase of error, no refill required (UX)) LocalStorage... (send unforfilled forms too...)
        // Successful --> Send data to AWS --> Mail / Message us
        // Confetti!!!
        setMakeConfetti(true);
        setMakeConfetti(false);
    };

    const onClear = () => {
        setStoredFormData('');
        reset();
    };

    const handleChange = () => {
        const values = getValues();
        setStoredFormData(values);
    };

    const handleSetForm = () => {
        Object.keys(storedFormData).forEach((key) => {
            setValue(key, storedFormData[key]);
        });
        if (storedFormData === '' || storedFormData === null || storedFormData === undefined)
            return;
        setContactSetting(storedFormData.contact);
    };

    return (
        <div id="am_route_content" className="franchisee">
            <Helmet defaultTitle="AutoMat | Bli Franchisetagare" titleTemplate="%s AutoMat" />
            <div className="am_confetti" />
            <div className="am_inner">
                <form onSubmit={handleSubmit(onSubmit)} onChange={handleChange}>
                    <div className="am_form_inner">
                        <p>{t('franchisee.form.greeting')}</p>
                        <p>
                            {t('franchisee.form.interest')}
                            <input
                                className="am_input"
                                name="location"
                                ref={register({
                                    required: true,
                                    pattern: /([a-zA-Z])/,
                                    maxLength: 40,
                                    minLength: 1,
                                })}
                                maxLength={40}
                                autoCorrect={'off'}
                                autoComplete={'off'}
                                placeholder={t('franchisee.form.interest-value')}
                                spellCheck={false}
                            />
                            {errors.location && <p>Format must be</p>}
                            {'. '}
                            {t('franchisee.form.building')}
                            <select
                                className="am_input"
                                name="building"
                                ref={register({
                                    required: true,
                                })}
                                style={{ margin: '0 1px 0 10px' }}
                            >
                                <option value="prefabricated">
                                    {t('franchisee.form.building-select-1')}
                                </option>
                                <option value="rented">
                                    {t('franchisee.form.building-select-2')}
                                </option>
                            </select>
                            {'. '}
                            {t('franchisee.form.contact')}
                            <select
                                className="am_input"
                                name="contact"
                                ref={register({
                                    required: true,
                                })}
                                onChange={() => setContactSetting(getValues().contact)}
                            >
                                <option value="email">
                                    {t('franchisee.form.contact-select-1')}
                                </option>
                                <option value="phone">
                                    {t('franchisee.form.contact-select-2')}
                                </option>
                            </select>
                            {contactSetting === 'email' ? (
                                <>
                                    {t('franchisee.form.email')}
                                    <input
                                        className="am_input"
                                        name="email"
                                        ref={register({
                                            required: true,
                                            pattern: /([a-zA-Z])/,
                                            maxLength: 40,
                                            minLength: 1,
                                        })}
                                        maxLength={40}
                                        autoCorrect={'off'}
                                        autoComplete={'off'}
                                        placeholder={t('franchisee.form.contact-select-1')}
                                        spellCheck={false}
                                    />
                                    {errors.email && <p>Format must be</p>}
                                </>
                            ) : (
                                <>
                                    {t('franchisee.form.number')}
                                    <input
                                        className="am_input"
                                        name="number"
                                        ref={register({
                                            required: true,
                                            pattern: /([0-9])/,
                                            maxLength: 20,
                                            minLength: 1,
                                        })}
                                        maxLength={40}
                                        autoCorrect={'off'}
                                        autoComplete={'off'}
                                        placeholder={t('franchisee.form.contact-select-2')}
                                        spellCheck={false}
                                    />
                                    {errors.number && <p>Format must be</p>}
                                </>
                            )}
                            {'. '}
                        </p>
                        <p style={{ paddingTop: 30 }}>
                            {t('franchisee.form.end')}
                            <input
                                className="am_input"
                                name="name"
                                ref={register({
                                    required: true,
                                    pattern: /([a-zA-Z])/,
                                    maxLength: 40,
                                    minLength: 1,
                                })}
                                maxLength={40}
                                autoCorrect={'off'}
                                autoComplete={'off'}
                                placeholder={t('franchisee.form.end-value')}
                                spellCheck={false}
                            />
                            {'.'}
                            {errors.name && <p>Format must be...</p>}
                        </p>
                        <div className="am_form_buttons">
                            <Confetti active={makeConfetti} config={confettiConfig} />
                            <button
                                type="button"
                                className="am_franchise_button"
                                name="clear"
                                onClick={onClear}
                            >
                                {t('franchisee.clear')}
                            </button>
                            <button type="submit" className="am_franchise_button">
                                {t('franchisee.button')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Franchisee;
